import { useReactiveVar } from '@apollo/client';

import { sharedClientDocumentVariable } from '@xing-com/crate-lebenslauf-shared-client-document-variable';
import type { VitaDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

export const useReadVitaReactiveVariable = (): VitaDocumentType => {
  return useReactiveVar(sharedClientDocumentVariable);
};
